<template>
  <div class="bsp-root">
    <div class="bsp-wrap">
      <div class="text-center mb-3">
        <img :src="$brand.logo" :alt="$brand.name" class="bsp-logo" />
        <div class="bsp-brand">{{ $brand.name }}</div>
        <div class="bsp-tag">Blood Bank Live Status — Donate Where It Matters Most</div>
      </div>

      <div v-if="loading" class="text-center text-muted py-5">Loading current stock…</div>
      <div v-else-if="error" class="bsp-error">{{ error }}</div>

      <div v-else>
        <div class="bsp-facility">
          <i class="mdi mdi-hospital-building"></i>
          <div>
            <div class="bsp-fname">{{ facility.name }}</div>
            <div class="bsp-sub">As of {{ formatTime(asOf) }}</div>
          </div>
        </div>

        <div class="bsp-callout" :class="{ urgent: needsDrive }">
          <i class="mdi" :class="needsDrive ? 'mdi-alert-decagram' : 'mdi-heart-pulse'"></i>
          <strong>{{ message }}</strong>
        </div>

        <div class="bsp-grid">
          <div v-for="g in groups" :key="g.blood_group" class="bsp-card" :class="'lvl-' + g.level">
            <div class="bsp-group">{{ g.blood_group }}</div>
            <div class="bsp-level">{{ levelLabel(g.level) }}</div>
            <div class="bsp-status">{{ statusLabel(g.status) }}</div>
          </div>
        </div>

        <div class="bsp-info">
          <h4>Who can donate?</h4>
          <ul>
            <li>Aged 18–65, in good health, weight ≥ 50 kg.</li>
            <li>No recent illness, surgery, or tattoo in the last 6 months.</li>
            <li>Bring a national ID. Donation takes about 30 minutes.</li>
          </ul>
          <h4>Why donate?</h4>
          <p>One donation can save up to three lives — for mothers in childbirth, road-accident
          victims, sickle-cell patients and surgical care.</p>
          <p class="bsp-foot">A community service of {{ facility.name }} and the Kenya National Blood
          Transfusion Service (KNBTS) framework.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { hms } from "@/api";

export default {
  name: "BloodStatusPublic",
  data() {
    return {
      loading: true, error: "",
      facility: {}, groups: [], needsDrive: false, message: "", asOf: ""
    };
  },
  mounted() {
    document.title = `Blood Bank — Live Status | ${this.$brand.name}`;
    this.load();
  },
  methods: {
    async load() {
      var h = this.$route.query.h || this.$route.query.hospital_id || 11;
      try {
        var r = await axios.post(hms + "?function=getBloodStockPublic", { hospital_id: h }, {
          headers: { "Content-Type": "application/json" }
        });
        var d = r.data || {};
        if (d.success) {
          var x = d.data || {};
          this.facility = x.facility || {};
          this.groups   = x.groups || [];
          this.needsDrive = !!x.needs_drive;
          this.message  = x.message || "";
          this.asOf     = x.as_of || "";
        } else {
          this.error = d.message || "Could not load status.";
        }
      } catch (e) { this.error = "Unable to reach the blood-bank service."; }
      this.loading = false;
    },
    levelLabel(l) { return ({ none:"NEEDED — donate", low:"Low — donations welcome", fair:"Fair", good:"Well stocked" })[l] || l; },
    statusLabel(s) { return ({ critical:"Critically low", low:"Below threshold", ok:"OK" })[s] || s; },
    formatTime(s) { if (!s) return ""; var d = new Date(s); return isNaN(d) ? s : d.toLocaleString(); }
  }
};
</script>

<style scoped>
.bsp-root { min-height: 100vh; background: linear-gradient(180deg, #fff 0%, #f4f6f9 100%); padding: 24px 16px; color: #1a1a1a; }
.bsp-wrap { max-width: 760px; margin: 0 auto; }
.bsp-logo { height: 56px; }
.bsp-brand { color: #0047AB; font-size: 22px; font-weight: 800; letter-spacing: 2px; margin-top: 6px; }
.bsp-tag { color: #555; font-size: 13px; font-style: italic; }
.bsp-facility { display: flex; align-items: center; gap: 12px; background: #fff; border: 1px solid #e0e6ed; border-radius: 12px; padding: 12px 16px; margin: 18px 0 14px; }
.bsp-facility i { font-size: 28px; color: #0047AB; }
.bsp-fname { font-weight: 700; }
.bsp-sub { color: #6b7280; font-size: 12px; }
.bsp-callout { background: #f0f9ff; border: 1px solid #bae6fd; color: #0c4a6e; border-radius: 10px; padding: 12px 16px; margin-bottom: 16px; display: flex; gap: 10px; align-items: center; }
.bsp-callout.urgent { background: #fef2f2; border-color: #fecaca; color: #991b1b; }
.bsp-callout i { font-size: 22px; }
.bsp-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; }
@media (max-width: 540px) { .bsp-grid { grid-template-columns: repeat(2, 1fr); } }
.bsp-card { background: #fff; border: 1px solid #e0e6ed; border-radius: 12px; padding: 16px; text-align: center; }
.bsp-card.lvl-none { background: #fef2f2; border-color: #fca5a5; }
.bsp-card.lvl-low  { background: #fff7ed; border-color: #fdba74; }
.bsp-card.lvl-fair { background: #fef9c3; border-color: #fde68a; }
.bsp-card.lvl-good { background: #ecfdf5; border-color: #86efac; }
.bsp-group { font-size: 24px; font-weight: 800; color: #0047AB; }
.bsp-level { font-size: 12px; font-weight: 700; color: #1a1a1a; margin-top: 4px; }
.bsp-status { font-size: 11px; color: #6b7280; margin-top: 2px; }
.bsp-info { background: #fff; border: 1px solid #e0e6ed; border-radius: 12px; padding: 18px; margin-top: 18px; font-size: 13px; line-height: 1.55; }
.bsp-info h4 { color: #0047AB; font-size: 14px; margin: 0 0 6px; }
.bsp-foot { font-size: 11px; color: #6b7280; margin-top: 10px; }
.bsp-error { background: #fef2f2; border: 1px solid #fca5a5; color: #991b1b; border-radius: 10px; padding: 14px; }
</style>
